import { getBackendUrl } from "@Utils";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosWrapper from "../services/axiosWrapper";

export const saveDsrItemData = createAsyncThunk("dsr/saveDsrItemData", async (data, { rejectWithValue }) => {
  try {
    const responseData = await axiosWrapper.post(`${getBackendUrl()}/dsr/saveDsrItemData`, data);
    if (responseData.data.status) {
      return responseData.data.data;
    }
    return rejectWithValue(responseData.data);
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getDsrItemsData = createAsyncThunk("dsr/getDsrItemsData", async (data, { rejectWithValue }) => {
  try {
    const responseData = await axiosWrapper.post(`${getBackendUrl()}/dsr/getAllDsrItems`, data);
    if (responseData.status) {
      return responseData.data;
    }
    return rejectWithValue(responseData.data);
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

const saveDsrItemSlice = createSlice({
  name: "saveDsrItem",
  initialState: [],
  reducers: {
    saveDsrItem: (_state, action) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(saveDsrItemData.fulfilled, (_state, action) => action.payload);
  },
});

const dsrItemsSlice = createSlice({
  name: "dsrItems",
  initialState: [],
  reducers: {
    getDsrItems: (_state, action) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(getDsrItemsData.fulfilled, (_state, action) => action.payload);
  },
});

const costDatabaseSlice = createSlice({
  name: "costDatabase",
  initialState: {},
  reducers: {
    setCostDatabase: (_state, action) => action.payload,
  },
});

export const { saveDsrItem } = saveDsrItemSlice.actions;
export const { getDsrItems: getDsrItemsAction } = dsrItemsSlice.actions;
export const { setCostDatabase } = costDatabaseSlice.actions;

export const getDsrItems = dsrItemsSlice.reducer;
export const costDatabase = costDatabaseSlice.reducer;

export default {
  getDsrItems,
  costDatabase,
};
